import React from "react";

/**
 * Lightweight YouTube embed. Accepts full URLs, short urls, or bare video IDs.
 * Lazy by default (loading="lazy" on iframe).
 */
function extractId(input) {
  if (!input) return "";
  const s = String(input).trim();
  // Bare 11-char video id
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
  // youtu.be/<id>
  let m = s.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (m) return m[1];
  // youtube.com/watch?v=<id>
  m = s.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
  if (m) return m[1];
  // /embed/<id> or /shorts/<id>
  m = s.match(/\/(?:embed|shorts)\/([a-zA-Z0-9_-]{11})/);
  if (m) return m[1];
  return "";
}

export default function YouTubeEmbed({ url, title = "Video", className = "", testId = "yt-embed" }) {
  const id = extractId(url);
  if (!id) {
    return (
      <div className={`bg-gray-100 rounded-lg p-6 text-center text-sm text-gray-500 ${className}`} data-testid={`${testId}-invalid`}>
        Invalid YouTube URL
      </div>
    );
  }
  return (
    <div className={`relative w-full overflow-hidden rounded-lg bg-black ${className}`} style={{ paddingTop: "56.25%" }} data-testid={testId}>
      <iframe
        src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute inset-0 w-full h-full border-0"
      />
    </div>
  );
}

export { extractId as extractYouTubeId };
